import React from 'react';

import styles from './Hero.module.scss';

const Hero = (props) => (
  <div className={`${props.className ? props.className : ''} ${styles.Hero}${props.bgGreen ? ` ${styles.Hero__Green}` : `` }`}>
    <h1 dangerouslySetInnerHTML={{ __html: props.title }} className={`${props.underlineGreen ? `${styles.Hero__Underline__Green}` : `` }`} />
  </div>
)

export default Hero;



// WEBPACK FOOTER //
// ./src/components/ProgramOverview/Hero/index.js